import { ContentWrapper } from '@/components/organisms/Reports';
import { ReportTable, Tbody, Td, Th, Tr } from '@/components/organisms/Reports/ReportContent/ReportTable';
import { useAppSelector } from '@/hooks';
import { getJobProgressItemList, getProgressReportAction } from '@/redux/actions';
import { CORRELATION_IDS, selectHttpState } from '@/redux/reducers/http';
import { useEffect } from 'react';

const LeadToClientProgress = () => {
  const result = useAppSelector(selectHttpState)[CORRELATION_IDS.GET_PROGRESS_REPORT];
  const leadProgressBarList = useAppSelector(selectHttpState)[CORRELATION_IDS.GET_PROGRESS_LIST];

  const fetchProgressItems = () =>
    getJobProgressItemList({
      progressType: 'lead',
    });

  useEffect(() => {
    getProgressReportAction({
      report_type: 'lead',
    });
    fetchProgressItems();
  }, []);

  return (
    <>
      <ContentWrapper headings={['Lead to Client | Progress']}>
        <ReportTable tableContainerClass='no-border-bottom' marginBottom={'5px'}>
          <Tbody>
            <Tr>
              {((leadProgressBarList && leadProgressBarList?.data?.data) ?? []).map((item: any, index: number) => {
                return (
                  <Th align={'center'} key={index}>
                    {item?.progress_name}
                  </Th>
                );
              })}
            </Tr>
            <Tr>
              {((leadProgressBarList && leadProgressBarList?.data?.data) ?? []).map((item: any, index: number) => {
                const find = (result?.data?.break_down ?? []).find((_: any) => _.id === item.id);
                return (
                  <Td align={'center'} key={index}>
                    {find?.customer_details_count || 0}
                  </Td>
                );
              })}
            </Tr>
            <Tr>
              {((leadProgressBarList && leadProgressBarList?.data?.data) ?? []).map((item: any, index: number) => {
                const find = (result?.data?.break_down ?? []).find((_: any) => _.id === item.id);
                return (
                  <Td align={'center'} key={index}>
                    {+find?.percent.toFixed(2) || 0}%
                  </Td>
                );
              })}
            </Tr>
          </Tbody>
        </ReportTable>

        <div className={'title-bar footer-title'}>Total Leads: {result?.data?.total_count}</div>
      </ContentWrapper>
    </>
  );
};

export { LeadToClientProgress };
